module.exports = __webpack_public_path__ + "img/9.c6abe6e2.jpg";